import { useState } from 'react';
import EDLink from '../../../../../../BaseComponents/Link/EDLink';
import EDTooltip from '../../../../../../BaseComponents/Tooltip/EDTooltip';
import EDDialog from '../../../../../../BaseComponents/Dialog/EDDialog';
import EDTypography from '../../../../../../BaseComponents/Typography/EDTypography';

interface IProps {
  startOpen?: boolean;
  onClose?: () => void;
  setOpen?: React.Dispatch<React.SetStateAction<boolean>>;
  testId?: string;
}

export const EDTeamViewerLink: React.FunctionComponent<
  React.PropsWithChildren<IProps>
> = props => {
  const [dialogOpen, setDialogOpen] = useState(props.startOpen ?? false);

  return (
    <>
      <EDTooltip
        title={
          'Klicka här för att hantera nedladdning av programmet TeamViewer'
        }
      >
        <EDLink
          testId="openTeamViewerDialog"
          onClick={event => {
            event.preventDefault();
            event.stopPropagation();
            setDialogOpen(true);
          }}
        >
          Fjärrsupport
        </EDLink>
      </EDTooltip>
      <EDDialog
        testId="teamviewer_link"
        title="Eniac fjärrsupport"
        open={dialogOpen}
        footerActions={[
          {
            label: 'Stäng',
            onClick: () => {
              setDialogOpen(false);
              props.onClose && props.onClose();
            },
          },
          {
            testId: 'teamviewer_downloadButton',
            label: 'Ladda ner',
            onClick: () => {
              window.open('https://get.teamviewer.com/6fsmib9', '_blank');
            },
            buttonProps: {
              primary: true,
              flat: false,
            },
          },
        ]}
        onClose={() => {
          setDialogOpen(false);
          props.onClose && props.onClose();
        }}
      >
        <EDTypography variant="h6" bold>
          Vi erbjuder support via TeamViewer
        </EDTypography>
        <br />
        <EDTypography>
          För att ge dig snabb och effektiv hjälp kan vi ibland behöva
          fjärrstyra din dator. Vi använder <b>TeamViewer</b> - ett säkert och
          tillförlitligt verktyg för fjärrsupport.
        </EDTypography>
        <br />
        <EDTypography>
          Klicka på knappen nedan för att ladda ner en fil som du behöver öppna.
          Observera att ingen programvara kommer att installeras på din dator.
        </EDTypography>
      </EDDialog>
    </>
  );
};
